module.exports = __webpack_public_path__ + "fonts/icomoon.4b0e6a3.ttf";